module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAQAAAC1+jfqAAABMklEQVQoz3WRO05CURRFT4yhomYcxiFQ0TGla7CAgBHtDJU2VqiBBEdAB9Qo/mJCQULzeDzu03vuWTaKMcS9u712t0T+hEMO5L+Esp9jmJ+H8g70Fb/AMvr0ycD8wle2MK/6JbbmDvfdO9ZgfplXRcS/Yyu6W/jTLisw/y7+DUu52TnckIL5NxHJqxohocsRDscRXRJAY14VkayparwyIbLklluWRCa8YqhmTQkKD9RxtBmhKCNOcdR5BIIKpfUwmjKmgeOEFo4GY5Ro6yEloZjdR4ts+GBIkyZDPtgQUcsGFCUEeKLFMQMSPvkkYUCNFs9ACJJ2YjSmtHHU6NGjhqPNFCPGtCMiFLJrjcaMMxyOc2YYGrNrCr8W99MrVeOFFwzV9JL9HWHspZ2gQTcX7P2uXyF8W/wyJlvgAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon_navi_data.png
// module id = /2Fa
// module chunks = 1 2 3